<script setup lang="ts">
import type { IUiTableColumn } from '@/components/UiTable/UiTable.types'
import type { ICalendarEventListItem } from '@/types/shared-types'
import type { IProps } from './EventCalendarTable.types'
import AddToCalendarButton from '@/domains/investor/event-calendar/components/AddToCalendarButton/AddToCalendarButton.vue'
import { formatDate } from '@/utils/date'

defineProps<IProps>()

const { t } = useI18n()

const columns = computed<IUiTableColumn<ICalendarEventListItem>[]>(() => [
  {
    key: 'date',
    title: t('investor.eventCalendar.table.date'),
    width: '18rem',
    value: item => formatDate(item.date),
  },
  {
    key: 'event',
    title: t('investor.eventCalendar.table.event'),
    value: item => item.title,
  },
  {
    key: 'save',
    title: t('investor.eventCalendar.table.save'),
    width: '19rem',
  },
])
</script>

<template>
  <UiTable
    :columns="columns"
    :items="events"
  >
    <template #cell-save="{ item }">
      <AddToCalendarButton :event="item" />
    </template>
  </UiTable>
</template>
